import * as React from 'react';
import request  from '@/server/request';
import config from '@/server/config';
import * as ClipboardJS from 'clipboard';
 const Toast = require('react-toast-mobile');

let isLast = false;

class PurchaseOrder extends React.Component <any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
        dataList: [],
        page: 1,
        pageSize: 15,
        tabList: [],
        tabIndex: 0,
        tabCode: '',
        unReadCountNum: 0
    };
  }

  public loadBtn = true;

  public componentDidMount() {
    // 获取导航数据
    this.getTabList();

    this._getData(0);
    this.getUnredCount();

    const _THIS = this;

    window.onscroll = function() {
        if(document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 50||document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 50) {
            if(!_THIS.loadBtn){
                return ;
            }

            _THIS.setState({
                page: _THIS.state.page + 1,
            }, () => {
                if (_THIS.loadBtn) {
                    _THIS._getData(_THIS.state.tabIndex);

                }
            });
        }
    }
  }

  private tabAction(index: Number, code: any) {
    if (this.state.tabIndex === index) return;
    this.loadBtn = true;
    isLast = false;
    this.setState({
      tabIndex: index,
      tabCode: code,
      page: 1,
      dataList: []
    }, () => {
      this._getData(index);
    });
  }

  public render() {
    const { tabList, dataList, unReadCountNum } = this.state;
    return (
      <div className="page-gray">
        <ul className="wdcg">
          <li onClick={() => this.tabAction(0, '')} className={this.state.tabIndex === 0 ? 'current' : ''}>全部</li>
          {
            tabList.map((v: any, k:any) => <li key={v.code} onClick={() => this.tabAction(k+1, v.code)} className={this.state.tabIndex === k+1 ? 'current' : ''}>{v.value}</li>)
          }
        </ul>
        <div className="wdcgcon block">
          {
            unReadCountNum > 0 ? <div className="cgtip"><p className="newTip">有{unReadCountNum}条最新报价</p></div> : null
          }
          {
            dataList.length > 0 ?
            <ul>
            {
              dataList.map((v: any, k: number) => {
                  return (
                      <li key={k} onClick={() => this.navigateDetail(v.stItemInfoId)}>
                        <div className="cgtop">
                          <b>{v.stPublishTimeValue}</b>
                          <em className="red">{v.orderStateValue}</em>
                          {
                            v.spPriceAskNotReadCount > 0 ? <label>{v.spPriceAskNotReadCount}</label> : null
                          }
                        </div>
                        <div className="cgbtm">
                          <span>采购内容</span>
                          <p>{v.stBreed} {v.stGrade} {v.stNumber}{v.stUnitStr}</p>
                          <div className="cg-item-btns">
                            <a href="javascript: void(0);">查看详情</a>
                            {(v.orderState === 1 || v.orderState === 2) && v.state !== '1' && <div className="copy-btn" data-clipboard-text={`${config.WAPAPI}buy/quotation.htm?stItemInfoId=${v.stItemInfoId}&share=share`} onClick={this.shareData}>分享</div>}
                          </div>
                        </div>
                      </li>
              )})
            }
            </ul> :
            (!this.loadBtn && isLast ? <div className="upgrade">
                <div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>您没有任何求购信息</p></div>
                <div className="upgrade-btm">
                    <div className="upgrade-btn"><a href="javascript:;"  className="release" onClick={() => this.navigateToPur() } >发布求购</a></div>
                </div>
            </div> : null)
          }
        </div>
        { isLast ? '' : <div className="purchaseloading" id="loading"><img src={require('../../../assets/images/gif.gif')} /><span>正在加载...</span></div> }
      </div>
    )
  }

  private navigateToPur() {
      window.location.href = `${config.WAPAPI}buy/supplyBuyOnline.htm`;
  }

  private  async _getData(index: Number) {
    if(!this.loadBtn) {
        return ;
    }

    this.loadBtn = false;

    const r = await request({
        method: 'post',
        data: {
            orderState: this.state.tabCode,
            pageNum: this.state.page,
            pageSize: this.state.pageSize,
        },
        url: `${config.API2}member/st/list`,
    });

    if (this.state.tabIndex !== index) return;
    if(r.obj.pageNum >= r.obj.pages) {
        this.loadBtn = false;
        isLast = true;
    }else {
        this.loadBtn = true;
    }
    if(r.code === 1) {
        this.setState({
            dataList: this.state.dataList.concat( r.obj.list),
        });
        setTimeout(() => {
          new ClipboardJS('.copy-btn').on('success', function(e) {
              Toast.T.notify('链接已复制，转发分享给好友');
              e.clearSelection();
          });
        }, 500)
    }
  }

  private async getTabList() {
    const r = await request({
      url: `${config.API2}bjt/st/stInfoNav`
    });

    if (r.code === 1) {
      this.setState({
        tabList: r.obj
      });
    }
  }

  /**
   * [ 跳转详情 ]
   * @param itemId {Number} 项id
   */
  private navigateDetail(itemId: Number) {
    this.loadBtn = true;
    isLast = false;
    this.props.history.push('/purchaseOrderDetail?id=' + itemId);
  }

  private async getUnredCount() {
    const r = await request({
      url: `${config.MALLAPI}api/wshop/ask/remove-list`,
      data: {
        recordType: 8,
        type: 1,
        status: 1
      },
      method: 'post'
    });

    if (r.error_code === 0) {
      this.setState({
        unReadCountNum: r.data.count
      });
    }
  }

  private shareData(event: any) {
    (event as any).stopPropagation()
  }
}

export default PurchaseOrder;
